import React from 'react';
import { Input } from 'antd';
import styled from '@emotion/styled';
import { appStyles } from '../../../styles';

interface ConfirmActionProps {
  textConfirmAction: string | React.ReactElement;
  textConfirmPassword: string | React.ReactElement;
  isConfirmPassword?: boolean;
  getPassword?: (password: string) => void;
}

export const ConfirmAction = (props: ConfirmActionProps) => {
  return (
    <StyledWrapper>
      <p>{props.textConfirmAction}</p>
      {props.isConfirmPassword && (
        <>
          <p>{props.textConfirmPassword}</p>
          <Input
            type="password"
            onChange={e => {
              if (props.getPassword) {
                props.getPassword(e.target.value);
              }
            }}
            id="inputPasswordForConfirm"
            placeholder="Password"
          />
        </>
      )}
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  display: block;
  & input[type='password'] {
    ${appStyles.commonBorderRadius}
    height: 36px;
  }
`;
